import { useState, useEffect } from "react";

export const useBodySize = () => {
  const bodyElement = document.body;
  const [size, setSize] = useState({
    width: 0,
    height: 0,
  });

  useEffect(() => {
    const handleResize = (entries: ResizeObserverEntry[]) => {
      if (entries[0]) {
        setSize({
          width: entries[0].contentRect.width,
          height: entries[0].contentRect.height,
        });
      }
    };

    const resizeObserver = new ResizeObserver((entries) =>
      handleResize(entries)
    );

    if (bodyElement) {
      resizeObserver.observe(bodyElement);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, [bodyElement]);

  return size;
};
